/**
 * @voltxampere/schema — Net
 *
 * Per SPECS §1.2. A Net groups nodes under a single electrical identity
 * (by name). Exactly one Net per circuit may carry `isGround: true`; that
 * cross-circuit invariant is enforced by `validateCircuitInvariants`, not
 * by this schema alone.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
export const NetSchema = z
    .object({
    id: z.string(),
    name: z
        .string()
        .regex(/^[a-zA-Z_][a-zA-Z0-9_]*$/)
        .max(64),
    label: z.string().optional(),
    color: z
        .string()
        .regex(/^#[0-9a-fA-F]{6}$/)
        .optional(),
    isGround: z.boolean().default(false),
})
    .strict();
//# sourceMappingURL=net.js.map